import { Menu as MenuIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { LanguageSwitcher } from '../components/language-switcher'
import { NotificationBell } from '../features/alerts/notification-bell'
import { UserMenu } from '../components/user-menu'
import { ThemeToggle } from '../theme/theme-toggle'
import { NAV_ITEMS } from './nav-items'

export function Topbar({ onOpenMenu }: { onOpenMenu: () => void }) {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  // Longest match wins so a future /trips/:id still titles itself "Trajets".
  const current = [...NAV_ITEMS]
    .sort((a, b) => b.path.length - a.path.length)
    .find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`))

  return (
    <header className="fc-safe-topbar flex shrink-0 items-center gap-2 border-b border-border bg-surface px-3 sm:px-4">
      <button
        type="button"
        onClick={onOpenMenu}
        aria-label={t('common:sidebar.openMenu')}
        className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-muted transition-colors hover:bg-surface-hover hover:text-foreground lg:hidden"
      >
        <MenuIcon aria-hidden className="h-5 w-5" />
      </button>

      <h1 className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">
        {current ? t(`nav:items.${current.key}`) : t('common:appName')}
      </h1>

      <div className="flex items-center gap-1">
        <NotificationBell />
        {/* On a phone these two moved into the user menu: four icons left the page
            title three words wide ("Tableau de bo…"). */}
        <div className="hidden items-center gap-1 sm:flex">
          <LanguageSwitcher />
          <ThemeToggle />
        </div>
        <UserMenu />
      </div>
    </header>
  )
}
